import { z } from 'zod'
import { StationType, StationSource, LineCategory } from '../../../shared/enums'

const uuid = () => z.string().uuid()

const scopedSchema = z.object({
  organizationId: uuid(),
  tenantId: uuid(),
})

export const railStationCreateSchema = scopedSchema.extend({
  code: z.string().min(1).max(10),
  name: z.string().min(1).max(200),
  nameInternational: z.string().max(200).optional().nullable(),
  city: z.string().min(1).max(100),
  voivodeship: z.string().max(50).optional().nullable(),
  country: z.string().min(3).max(3).default('POL'),
  latitude: z.coerce.number().min(-90).max(90),
  longitude: z.coerce.number().min(-180).max(180),
  stationType: z.nativeEnum(StationType),
  infrastructureManager: z.string().min(1).max(200),
  source: z.nativeEnum(StationSource),
  externalId: z.string().max(100).optional().nullable(),
  isElectrified: z.boolean().optional(),
  maxTrainLengthM: z.number().int().optional().nullable(),
  trackCount: z.number().int().optional().nullable(),
  hasCrane: z.boolean().optional(),
  hasWeighbridge: z.boolean().optional(),
  hasReachstacker: z.boolean().optional(),
  terminalCapacityTeu: z.number().int().optional().nullable(),
  lineNumbers: z.string().max(500).optional().nullable(),
  kmMarker: z.coerce.number().min(0).optional().nullable(),
  isActive: z.boolean().optional(),
})

export type RailStationCreateInput = z.infer<typeof railStationCreateSchema>

export const railStationUpdateSchema = z.object({
  id: uuid(),
}).merge(railStationCreateSchema.partial())

export type RailStationUpdateInput = z.infer<typeof railStationUpdateSchema>

export const railSegmentCreateSchema = scopedSchema.extend({
  fromStationId: uuid(),
  toStationId: uuid(),
  distanceKm: z.coerce.number().min(0),
  lineNumber: z.string().min(1).max(10),
  lineCategory: z.nativeEnum(LineCategory),
  isElectrified: z.boolean(),
  maxSpeedKmh: z.number().int().optional().nullable(),
  maxAxleLoadTons: z.coerce.number().optional().nullable(),
  infrastructureManager: z.string().min(1).max(200),
  gaugeMm: z.number().int().default(1435),
  tariffZone: z.string().max(20).optional().nullable(),
  source: z.nativeEnum(StationSource),
  externalId: z.string().max(100).optional().nullable(),
  isActive: z.boolean().optional(),
})

export type RailSegmentCreateInput = z.infer<typeof railSegmentCreateSchema>

export const railSegmentUpdateSchema = z.object({
  id: uuid(),
}).merge(railSegmentCreateSchema.partial())

export type RailSegmentUpdateInput = z.infer<typeof railSegmentUpdateSchema>
